module.exports = "/_next/static/images/ai_equity_search-a562e92b1c22ec10cb8764738d199aab.png";